import { ReportLeadCard } from '../shared/ReportLead';
import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import { useTheme } from '@mui/material/styles';

import LightGrid from '../LightGrid';

// MUI v6: Styles are handled with the 'sx' prop and hooks like useTheme

const LightBoxes = (props) => {
    const theme = useTheme();
    const [openNewLBE, setOpenNewLBE] = useState(false);

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="left" ref={ref} {...props} />;
    });

    const handleClose = () => {
        setOpenNewLBE(false);
    };

    const handleClickOpenLBE = () => {
        setOpenNewLBE(true);
    };

    return (
        <div>
            <ReportLeadCard eyebrow="Onsite messages" title="Lightbox performance" description="Review onsite messages active during the selected period." />

            <LightGrid {...props} />

            {/* Example: If you want to add the FAB back in for adding new LBE */}
            {/* <Fab
                color="primary"
                aria-label="add"
                onClick={handleClickOpenLBE}
                sx={{
                    position: 'fixed',
                    bottom: theme.spacing(2),
                    right: theme.spacing(2),
                }}
            >
                <AddIcon />
            </Fab>

            <Dialog
                fullScreen
                open={openNewLBE}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'primary.main' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            New LightBox
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Paper sx={{ p: 3 }}>
                    <LightBoxSettings onClose={handleClose} />
                </Paper>
            </Dialog> */}
        </div>
    );
};

export default LightBoxes;
